import React from 'react';
import './CartModifierName.less';

export const CartModifierName = ({text}) => {
	return <span className="cart-modifier-name">{text}</span>;
};
